@if(!loaded()) {
<div class="rsr-loading">
  <span class="loading-text">
    <mat-icon>info</mat-icon>
    {{ text() }}
  </span>
  <svg role="presentation" width="100%" height="4" viewBox="0, 0, 100, 4" preserveAspectRatio="xMidYMid slice">
    <rect x="0" y="0" class="loading-mask" width="100" height="4"></rect>
    <rect [attr.x]="xPos" y="0" class="loading-indicator" width="32" height="4"></rect>
  </svg>
</div>
}

